const COLUMN_VALUE_GETTERS = {
    closureStatus: (defect) => {
        if (defect?.closure_status === "Not Approved") return "In Progress";
        return String(defect?.closure_report || "").trim() ? "Closed" : "Open";
    },
};

export function getDefectColumnValue(defect, columnOrField) {
    const column =
        typeof columnOrField === "string"
            ? { field: columnOrField }
            : columnOrField;

    if (column?.valueGetter) {
        const getter = COLUMN_VALUE_GETTERS[column.valueGetter];
        if (getter) return getter(defect);
    }

    if (column?.field === "Status") {
        return COLUMN_VALUE_GETTERS.closureStatus(defect);
    }

    if (column?.field === "component") {
        return defect?.component || defect?.area || "";
    }

    return defect?.[column?.field];
}
